export default __webpack_public_path__ + "static/media/icons8-attach-48.ef84dcd1.svg";